import React from 'react';
import {
  Type,
  Heading1,
  Heading2,
  Heading3,
  List,
  ListOrdered,
  Quote,
  Code,
  Info,
  ChevronRight,
} from 'lucide-react';

const BLOCK_TYPES = [
  { key: 'paragraph', label: 'Text', icon: Type },
  { key: 'h1', label: 'Heading 1', icon: Heading1 },
  { key: 'h2', label: 'Heading 2', icon: Heading2 },
  { key: 'h3', label: 'Heading 3', icon: Heading3 },
  { key: 'bullet', label: 'Bulleted List', icon: List },
  { key: 'number', label: 'Numbered List', icon: ListOrdered },
  { key: 'quote', label: 'Quote', icon: Quote },
  { key: 'code', label: 'Code', icon: Code },
  { key: 'callout', label: 'Callout', icon: Info },
  { key: 'toggle', label: 'Toggle List', icon: ChevronRight },
];

const TurnIntoSubmenu = ({ currentBlockType, onSelect }) => {
  return (
    <div className="turn-into-submenu">
      <div className="turn-into-label">Turn into</div>
      <div className="turn-into-list">
        {BLOCK_TYPES.map((block) => {
          const Icon = block.icon;
          const isActive = currentBlockType === block.key;
          return (
            <button
              key={block.key}
              type="button"
              className={`turn-into-item ${isActive ? 'active' : ''}`}
              onClick={() => onSelect(block.key)}
            >
              <Icon size={16} strokeWidth={1.5} />
              <span>{block.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TurnIntoSubmenu;
